import { render, staticRenderFns } from "./addThematicArea.vue?vue&type=template&id=4942b085&scoped=true"
import script from "./addThematicArea.vue?vue&type=script&lang=js"
export * from "./addThematicArea.vue?vue&type=script&lang=js"
import style0 from "./addThematicArea.vue?vue&type=style&index=0&id=4942b085&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4942b085",
  null
  
)

export default component.exports